module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"dialogTitle":"Benutzer wechseln","userSwitch":"Wechseln","userSwitchBack":"Zurück"},"fr":{"dialogTitle":"Changer d\u0027utilisateur","userSwitch":"Échanger","userSwitchBack":"Retour"},"it":{"dialogTitle":"Cambiare utente","userSwitch":"Cambiare","userSwitchBack":"Indietro"}}')
  delete Component.options._Ctor
}
